import office from "../assest/News/office.jpg";
import Image11 from "../assest/GreenHome/images/Image11.jpg";
import { greenHomeOutterRenderPaths } from "../assest/imgPaths";

export const NewsList = [
  {
    id: 1,
    pathName: "office-offer",
    img: office,
    header: "საუკეთესო სივრცე შენი საქმიანობისათვის",
    type: "სტატია",
    date: "09.02.2025", // dd-mm-yyyy
    unstyledText:
      "ეძებ საოფისე ფართს ქუთაისში? მაშინ მოდი და შეარჩიე შენს საჭიროებებზე მორგებული კვადრატულობის ფართი, ქუთაისის ყველაზე ხალხმრავალ უბანში განავითარე შენი ბიზნესი კონკურენტულ გარემოში",
    text: `
      <p class="font-semibold ">ეძებ საოფისე ფართს ქუთაისში?</p>
      <br/>
      
      <p class="text-xl italic font-bold ">მაშინ მოდი და შეარჩიე შენს საჭიროებებზე მორგებული კვადრატულობის ფართი, ქუთაისის ყველაზე ხალხმრავალ უბანში განავითარე შენი ბიზნესი კონკურენტულ გარემოში</p>
      <br/>
      <p class="italic text-primary-orange"> დეტალური ინფორმაციის მისაღებად გვეწვიეთ გაყიდვების ოფისში ან დაგვიკავშირდით</p>
    `,
  },
  {
    id: 2,
    pathName: "entrepreneur",
    img: greenHomeOutterRenderPaths.light,
    imggiorgi: Image11,
    header: "K2 Invest - როცა ხარისხი პრიორიტეტია",
    type: "სტატია",
    date: "25.06.2024", // dd-mm-yyyy
    link: "https://www.entrepreneur.com/ka/zrdis-strategiebi/k2-invest-rotsa-khariskhi/476129?fbclid=IwZXh0bgNhZW0CMTEAAR0Mvljr9r8mDLfPdN_wSMPFBEUkQLlaKp83g6wvNhBjdiwmGVMzqtjL4Sw_aem_Zr_GJ5B0LlRnB5-2h46XFA",
    unstyledText:
      "K2 Invest-ი ქართულ დეველოპერულ ბაზარზე 2023 წლიდან ოპერირებს. კომპანია ქუთაისში ეკოლოგიურად სუფთა, ენერგოეფექტური საცხოვრებელი სახლების მშენებლობას ისახავს მიზნად, რომელიც ძველი ქალაქის არქიტექტურასთან ჰარმონიულად იქნება შერწყმული.",
    text: `
      <p ><strong>K2 Invest</strong>-ი ქართულ დეველოპერულ ბაზარზე 2023 წლიდან ოპერირებს. კომპანია ქუთაისში ეკოლოგიურად სუფთა, ენერგოეფექტური საცხოვრებელი სახლების მშენებლობას ისახავს მიზნად, რომელიც ძველი ქალაქის არქიტექტურასთან ჰარმონიულად იქნება შერწყმული.</p>
      <br/>
      
      <p >"გვსურს, რომ ჩვენ მიერ აშენებულმა სახლებმა ქუთაისის უბნებში ახალი საზოგადოებრივი ჰაბები გააჩინოს და მობინადრეებს შესაძლებლობა ჰქონდეთ, უბნიდან გაუსვლელად მიიღონ ის მრავალფეროვანი სერვისები, რომლებიც მათი სრულფასოვანი ცხოვრებისთვის მნიშვნელოვანია", - აღნიშნავს კომპანიის დირექტორი გიორგი კვიტივაძე.</p>
      <br/>
      <p>K2 Invest-ი პირველი დეველოპერული კომპანიაა ქუთაისში, რომლის მშენებლობაც სრულად "თიბისი" ბანკმა დააფინანსა. აღსანიშნავია, რომ როგორც დეველოპერული კომპანია, ისე "თიბისი" ბანკი, ყველა შესაძლო რისკს სრულად საკუთარ თავზე იღებენ. მომხმარებლებს კი შესაძლებლობა აქვთ, "თიბისი" კონცეპტის პერსონალური ბანკირების დახმარებით, ყოველგვარი დამატებითი ძალისხმევისა და რისკის გარეშე სასურველი ბინის მეპატრონეები გახდნენ.</p>
      <br/>

      
    `,
    text2: `
      <p><strong>"აღნიშნული ხელშეკრულება შესაძლებლობას გვაძლევს, ჩვენს მომხმარებლებს შევთავაზოთ უპრეცედენტო სერვისი იმერეთის რეგიონის დეველოპერულ ბიზნესში, კერძოდ, იპოთეკური სესხი გამარტივებული პირობით, ყოველგვარი შემოსავლების დადასტურების გარეშე", -</strong> აღნიშნავს კომპანიის დირექტორი გიორგი კვიტივაძე.</p>
      <br/>
      <strong>როგორია K2 Invest-ის სამშენებლო კომპლექსები?</strong>
      </br>
      <p>"K2 ავტომშენებელზე" კომპანიის პირველი პროექტია, რომლის მშენებლობაც ქუთაისში ყველაზე ხალხმრავალ უბანში - ავტოქარხნის დასახლებაში, ყოფილი პარლამენტის მიმდებარე ტერიტორიაზე მიმდინარეობს. როგორც კომპანიაში აღნიშნავენ, უბანი საბჭოთა არქიტექტურული სტილის საცხოვრებელი კორპუსების სიმრავლით გამოირჩევა, ამის ფონზე კი თანამედროვე საცხოვრებელი სახლების მშენებლობა დიდი პასუხისმგებლობაა.</p>
      
    `,
  },
];
